import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

interface Theme {
  key: string;
  image: string;
}

const CATEGORIES = '/assets/images/home/categories';

@Component({
  imports: [TranslocoDirective],
  selector: 'app-home-explore-themes',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './explore-themes.html',
})
export class ExploreThemes {
  protected readonly themes: Theme[] = [
    { key: 'wildlife', image: `${CATEGORIES}/1-wildlife-conservation.webp` },
    { key: 'nature', image: `${CATEGORIES}/2-nature-adventure.webp` },
    { key: 'culture', image: `${CATEGORIES}/3-culture-heritage.webp` },
    { key: 'science', image: `${CATEGORIES}/4-science-innovation.webp` },
    { key: 'agro', image: `${CATEGORIES}/5-agro-farming.webp` },
    { key: 'arts', image: `${CATEGORIES}/6-arts-creativity.webp` },
  ];
}
